import { useTranslation } from 'react-i18next';
import { useUsercentrics } from 'src/hooks/useUsercentrics';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';
import { SUPPORT_EMAIL_EGPT } from 'src/utils/utils';

export const InfoContainer = () => {
  const { t } = useTranslation();
  const { isAvailable: isConsentManagerAvailable, showPrivacySettings } =
    useUsercentrics();
  return (
    <div className="tw:flex tw:flex-col tw:items-center tw:gap-y-1 tw:min-w-0 tw:max-w-full">
      <div className="tw:flex tw:flex-row tw:flex-wrap tw:items-center tw:justify-center tw:gap-x-2 tw:gap-y-1 tw:min-w-0 tw:max-w-full tw:text-left">
        <span className="tw:text-text-secondary tw:text-md tw:font-normal tw:min-w-0">
          {t(T.needHelpContactUs)}
        </span>
        <a
          href={`mailto:${SUPPORT_EMAIL_EGPT}`}
          className="tw:text-brand tw:min-w-0 tw:shrink-0 hover:tw:opacity-80"
        >
          {SUPPORT_EMAIL_EGPT}
        </a>
      </div>
      {isConsentManagerAvailable ? (
        <button
          type="button"
          onClick={showPrivacySettings}
          className="tw:bg-transparent tw:border-0 tw:p-0 tw:cursor-pointer tw:text-text-secondary tw:text-sm tw:font-normal tw:underline hover:tw:opacity-80"
        >
          {t(T.privacySettings)}
        </button>
      ) : null}
    </div>
  );
};
